import { Link } from 'react-router-dom';

/**
 * A section heading with an optional action on the right — `.w-sech` from the
 * web design handoff.
 *
 * The eyebrow label is what makes a page of stacked sections scannable: "Closing
 * soonest / Ending in the next hour" says both what the list is ordered by and
 * what is in it, in the space one heading would take.
 */
export function SectionHead({
  label,
  title,
  actionLabel,
  actionTo,
  actionHref,
}: {
  label?: string;
  title: string;
  actionLabel?: string;
  /** An in-site route. */
  actionTo?: string;
  /** An external URL — used while a destination still lives outside the site. */
  actionHref?: string;
}) {
  return (
    <div className="w-sech">
      <div>
        {label ? (
          <div className="w-lbl" style={{ marginBottom: 7 }}>
            {label}
          </div>
        ) : null}
        <h2 className="w-h2">{title}</h2>
      </div>
      {actionLabel && actionTo ? (
        <Link to={actionTo} className="w-btn w-btn-out w-btn-sm">
          {actionLabel}
          <span aria-hidden>›</span>
        </Link>
      ) : actionLabel && actionHref ? (
        <a href={actionHref} target="_blank" rel="noreferrer" className="w-btn w-btn-out w-btn-sm">
          {actionLabel}
          <span aria-hidden>›</span>
        </a>
      ) : null}
    </div>
  );
}
